export const TIMELINE_TIMINGS = 'timeline-timings';
export const TIMELINE_CURRENT_TIME = 'timeline-current-time';
export const CONTROL_CURRENT_TIME = 'control-current-time';
export const CONTROL_PLAY = 'control-play';
export const CONTROL_PAUSE = 'control-pause';
export const CONTROL_REWIND = 'control-rewind';
export const CONTROL_FORWARDS = 'control-forwards';
